import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameSignature',
  standalone: false
})
export class NameSignaturePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    const nameArray = value.toString().split(' ');
    return nameArray.map((name) => name.charAt(0)).join('');
  }
}
